import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Fa from 'react-fontawesome';
import { connect } from 'react-redux';
import {
  Tooltip, OverlayTrigger,
} from 'react-bootstrap';

import { getEmailSignature } from '../../../../components/request-signature/reducer';
import { requestEmailSignatureForUser } from '../../../../components/request-signature/actions';

class EmailSignatureRenderer extends Component {
  constructor(props) {
    super(props);
    this.state = {
    };
    this.requestSignature = this.requestSignature.bind(this);
  }

  requestSignature(ev) {
    ev.preventDefault();
    const { organization } = this.props;
    const p = this.props.dispatch(requestEmailSignatureForUser(organization, this.props.data));
    p.then(
      () => {
        this.props.onSignatureSent(this.props.data);
      },
      (e) => {
        let msg = null;
        if (e.message) {
          msg = e.message;
        } else if (e.statusText) {
          msg = e.statusText;
        }
        if (msg) {
          const el = (<div>{msg}</div>);
          this.context.addNotification(el, { type: 'error' });
        }
      },
    );
    return p;
  }

  renderNotSent(value) {
    const id = this.props.data._id;
    const tip = (
      <Tooltip id={`${id}-sent-siganture-${value}`}>
        <div>
          Send request siganture email
        </div>
      </Tooltip>
    );
    return (
      <span>
        <OverlayTrigger trigger={['hover', 'focus']} placement="top" overlay={tip}>
          <a href="" onClick={this.requestSignature}>Sent Request</a>
        </OverlayTrigger>
      </span>
    );
  }

  renderSent(value) {
    const id = this.props.data._id;
    const tip = (
      <Tooltip id={`${id}-resent-siganture-${value}`}>
        <div>
          Resent request siganture email
        </div>
      </Tooltip>
    );
    return (
      <span>
        <span className="text-uppercase label label-warning">Sent</span>
        {' '}
        <OverlayTrigger trigger={['hover', 'focus']} placement="top" overlay={tip}>
          <a href="" onClick={this.requestSignature}><Fa name="refresh" /></a>
        </OverlayTrigger>
      </span>
    );
  }

  renderVerified() {
    return (
      <span><span className="text-uppercase label label-success">Verified</span></span>
    );
  }


  render() {
    const { emailSignature } = this.props;
    if (!emailSignature) {
      return null;
    }
    const value = emailSignature.signature;
    const { status } = emailSignature;
    if (status === 'loading') {
      return (<Fa name="spinner" spin className="text-muted" />);
    }

    if (!value) {
      return this.renderNotSent(value);
    } else if (value === 'sent') {
      return this.renderSent(value);
    } else if (value === 'verified') {
      return this.renderVerified();
    }

    return value;
  }
}

EmailSignatureRenderer.propTypes = {
  dispatch: PropTypes.func.isRequired,
  data: PropTypes.shape({
    _id: PropTypes.string.isRequired,
    email: PropTypes.string,
  }),
  value: PropTypes.string,
  emailSignature: PropTypes.shape({
    status: PropTypes.string, // loading, loaded, error
    signature: PropTypes.string,
  }),
  organization: PropTypes.shape({
    _id: PropTypes.string.isRequired,
  }).isRequired,
  onSignatureSent: PropTypes.func,
};
EmailSignatureRenderer.defaultProps = {
  data: null,
  value: null,
  emailSignature: {},
  onSignatureSent: () => {},
};
EmailSignatureRenderer.contextTypes = {
  addNotification: PropTypes.func.isRequired,
};


function mapStateToProps(state, ownProps) {
  let email = null;
  if (ownProps.data && ownProps.data.email) {
    ({ email } = ownProps.data);
  }
  return {
    emailSignature: email ? getEmailSignature(state, email) : null,
  };
}

export default connect(mapStateToProps)(EmailSignatureRenderer);
